<template>
  <div>
    <van-field
      v-if="readOnly"
      v-model="form.retailTime"
      label="零售日期"
      required
    />
    <van-field
      v-else
      v-model="form.retailTime"
      label="零售日期"
      required
      @click="showPicker"
    />

    <!-- <van-field
      v-model="form.morningCustomerCount"
      label="早上客流"
      type="number"
      required
      :readonly="readOnly"
    />

    <van-field
      v-model="form.eveningCustomerCount"
      label="晚上客流"
      type="number"
      required
      :readonly="readOnly"
    /> -->

    <van-field
      v-model="form.cashIncomeEur"
      label="现金收入"
      type="number"
      placeholder="本日营收现金收入总额(欧元)"
      required
      :readonly="readOnly"
    />

    <van-field
      v-if="supCurrency.indexOf('2') > -1"
      v-model="form.cashIncomeChf"
      label="法郎收入"
      type="number"
      placeholder="本日营收法郎收入总额(法郎)"
      required
      :readonly="readOnly"
    />

    <van-field
      v-if="supCurrency.indexOf('3') > -1"
      v-model="form.mealIncome"
      label="饭票收入"
      type="number"
      placeholder="本日营收饭票收入总额(饭票)"
      required
      :readonly="readOnly"
    />

    <van-field
      v-model="form.cardIncomeEur"
      label="刷卡收入"
      type="number"
      placeholder="本日营收刷卡收入总额(欧元)"
      required
      :readonly="readOnly"
    />

    <van-field
      v-model="form.incomePayply"
      label="ANCV"
      type="number"
      placeholder="本日营收ANCV收入总额(欧元)"
      required
      :readonly="readOnly"
    />

    <van-field
      v-model="form.otherIncomeEur"
      label="其他收入"
      type="number"
      placeholder="其他收入(欧元)"
      :readonly="readOnly"
    />

    <van-field
      v-if="supCurrency.indexOf('2') > -1"
      v-model="form.otherIncomeChf"
      label="法郎收入"
      type="number"
      placeholder="其他收入(法郎)"
      :readonly="readOnly"
    />

    <van-field
      v-if="supCurrency.indexOf('3') > -1"
      v-model="form.otherIncomeMeal"
      label="饭票收入"
      type="number"
      placeholder="其他收入(饭票)"
      :readonly="readOnly"
    />

    <van-field
      v-model="form.incomeRemark"
      label="收入备注"
      placeholder="其他收入的来源说明"
      :readonly="readOnly"
    />

    <van-field
      v-model="form.remark"
      label="总备注"
      :readonly="readOnly"
    />
    
    <van-popup
      v-model="datePicker"
      position="bottom"
    >
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :formatter="formatter"
        :min-date="minDate"
        :max-date="maxDate"
        @change="change"
        @confirm="confirm"
        @cancel="cancel"
      />
    </van-popup>
  </div>
</template>
<script>
import { Detail } from "@/api/daily";
export default {
  name: "Income",
  props: {
    form: {
      type: Object,
      default: () => {
        return {}
      }
    },
    detail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      datePicker: false,
      supCurrency: '',
      currentDate: new Date(),
      minDate: "",
      maxDate: "",
    }
  },
  computed: {
    readOnly(){
      if(this.detail || this.form.status > 1) return true
      return false 
    }
  },
  created() {
    const today = new Date(),
    y = today.getFullYear(),
    m = today.getMonth() + 1,
    d = today.getDate();
    const yesterday = new Date(new Date().setTime(new Date().getTime()-24*60*60*1000))
    this.minDate = yesterday
    this.maxDate = new Date(y, m-1, d)
    this.form.retailTime = this.formatTime(this.detail ? yesterday : today);
    this.supCurrency = JSON.parse(localStorage.getItem("sushiWechatShopInfo")).supCurrency;
    this.getDetail()
  },
  methods: {
    getDetail(){
      if(this.detail)
      return
			this.$toast.loading({
				duration: 0,
				message: '加载中...',
				forbidClick: true,
			});
			Detail({
        shopId: this.form.shopId,
        retailTime: this.form.retailTime
      }).then(res => {
				this.$toast.clear();
        if(res.code ==0 && res.dayDaily)
        if(res.dayDaily){
          if(!res.dayDaily.listDailyOut || res.dayDaily.listDailyOut.length === 0)
          res.dayDaily.listDailyOut = [
            {
              outProductName: "",
              currency: "1",
              outlayMoney: ""
            }
          ]
        }
        this.$set(this.$parent, 'ruleForm', res.dayDaily || {
          shopId: this.form.shopId,
          shopName: this.form.shopName,
          retailTime: this.form.retailTime,
          cardIncomeEur: "",
          cashIncomeEur: "",
          cashIncomeChf: "",
          incomePayply: "",
          mealIncome: "",
          remark: "",
          otherIncomeEur: "",
          otherIncomeChf: "",
          otherIncomeMeal: "",
          incomeRemark: "",
          outlayRemark: "",
          tDayCustomerCount: "",
          morningCustomerCount: "",
          eveningCustomerCount: "",
          listDailyOut: [
            {
              outProductName: "",
              currency: "1",
              outlayMoney: ""
            }
          ]
        })
			}).catch(() => {
				this.$toast.clear();
			})
		},
    change(){
      // this.form.retailTime = this.formatTime(this.currentDate);
      // this.getDetail(this.form.retailTime)
    },
    confirm(val){
      this.form.retailTime = this.formatTime(val);
      this.getDetail()
      this.datePicker = false
    },
    cancel(){
      this.datePicker = false
    },
    showPicker(){
      this.datePicker = true
    },
    formatTime(date){
      const y = date.getFullYear();
      let m = date.getMonth() + 1,
      d = date.getDate();
      if(m < 10)
      m = '0' + m
      if(d < 10)
      d = '0' + d
      return `${y}-${m}-${d}`
    },
    formatter(type, val) {
      if (type === 'year') {
        return val + '年';
      }
      if (type === 'month') {
        return val + '月';
      }
      if (type === 'day') {
        return val + '日';
      }
      return val;
    },
  }
};
</script>